import PropTypes from 'prop-types';
import { useState } from 'react';
import TextField from 'components/form-components/TextField';
import chevronGreyIcon from 'assets/images/icons/chevron-grey.svg';
import linkGreenIcon from 'assets/images/icons/link-green.svg';
import linkBrokenRedIcon from 'assets/images/icons/link-broken-red.svg';
import crossGreyIcon from 'assets/images/icons/cross-grey.svg';
import plusCircleFilledGreen from 'assets/images/icons/plus-circle-filled-green.svg';
import MultiLevelSelect from 'components/form-components/MultiLevelSelect';
import { useTranslation } from 'react-i18next';

const TextLink = ({ value, dashboardOptions, onChange }) => {
  const { t } = useTranslation();

  const [showContent, setShowContent] = useState(true);
  const ITEM_DEFAULT = { text: '', linkedPageId: '', linkedDashboardId: '' };
  // Ensure at least one row
  const optionList = value.length ? value : [ITEM_DEFAULT];

  const updateList = (newList) => {
    onChange(newList);
  };

  const addOptionToList = () => {
    updateList([...optionList, { ...ITEM_DEFAULT }]);
  };

  const removeOptionFromList = (index) => {
    const tempOptionList = [...optionList];
    tempOptionList.splice(index, 1);
    updateList(tempOptionList);
  };

  const handleOptionChange = (index, field, value, path) => {
    const newOptionList = [...optionList];

    if (field === 'linkDashboardPage') {
      newOptionList[index] = {
        ...newOptionList[index],
        linkedPageId: value,
        linkedDashboardId: path[path.length - 1],
      };
    } else {
      newOptionList[index] = {
        ...newOptionList[index],
        [field]: value,
      };
    }

    updateList(newOptionList);
  };

  return (
    <>
      <div className='text-and-link accordion d-flex flex-column'>
        <div className='accordion-item border-0 px-3 py-2 mb-0'>
          <div className='d-flex justify-content-between align-items-center'>
            <div className='d-flex text-nowrap gap-3'>
              <div>
                <span className='theme-text-black-1 theme-size-1_1 theme-font-inter-medium'>
                  {t('field_text_and_link')}
                </span>
                <span className='lh-1 theme-size-1_5 theme-text-red-1 px-1'>*</span>
              </div>
              <img
                className='cursor-pointer'
                src={plusCircleFilledGreen}
                onClick={() => addOptionToList()}
              />
            </div>
            <div className='toggle-button'>
              <img
                src={chevronGreyIcon}
                className={`cursor-pointer p-2 ${showContent ? '' : 'rotate-180'}`}
                onClick={() => setShowContent((prevState) => !prevState)}
              />
            </div>
          </div>
        </div>

        <div className='accordion-item border-0 theme-text-grey-1'>
          {showContent && (
            <div className='p-3 border-top-grey-10-h-1'>
              <div className='mb-2'>{t('text_connect_with_other_dashboard_or_page')}</div>
              <div className='d-flex flex-column gap-3'>
                {optionList.map((option, index) => (
                  <div key={index} className='d-flex align-items-center gap-3'>
                    <div
                      key={index}
                      className='position-relative d-flex flex-grow-1 align-items-center gap-3'
                    >
                      <TextField
                        name='text'
                        classes='w-100 textInput'
                        value={option.text}
                        handleChange={(name, value) => handleOptionChange(index, name, value)}
                        placeholder='field_label'
                        shrinkFieldOnly
                      />
                      <div className='d-flex align-items-center position-absolute end-0 theme-height-44 px-3 py-2'>
                        {optionList[index].linkedPageId ? (
                          <div
                            className={`d-flex gap-2 cursor-pointer`}
                            onClick={() => handleOptionChange(index, 'linkDashboardPage', '', [''])}
                          >
                            <img src={linkBrokenRedIcon} />
                            <label className='theme-text-red-1 cursor-pointer'>{'Unlink'}</label>
                          </div>
                        ) : (
                          <MultiLevelSelect
                            options={dashboardOptions}
                            value={[]}
                            name='linkDashboardPage'
                            disabled={dashboardOptions.children?.length === 0}
                            handleChange={(name, value, displayValue, path) => {
                              handleOptionChange(index, name, value[0], path);
                            }}
                            classes='theme-font-inter-regular'
                            toggleClasses='d-flex gap-2 justify-content-between align-items-center cursor-pointer'
                            toggleComponent={
                              <>
                                <img src={linkGreenIcon} />
                                <label className='theme-text-green-1 cursor-pointer'>
                                  {'Link'}
                                </label>
                              </>
                            }
                          />
                        )}
                      </div>
                    </div>
                    <div>
                      <img
                        src={crossGreyIcon}
                        role='button'
                        className={` theme-width-20 ${
                          optionList.length > 1 ? 'cursor-pointer' : 'opacity-50 svg-grey pe-none'
                        }`}
                        onClick={() => removeOptionFromList(index)}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

TextLink.propTypes = {
  value: PropTypes.array.isRequired,
  dashboardOptions: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default TextLink;
